<template>
  <v-container class="fill-height" :style="`height: ${value}px`">
    <v-row class="d-flex flex-column" justify="center" align="center">
      <v-progress-circular
        :size="value * 0.8"
        width="1"
        indeterminate
        color="#DCDCDC"
      >
        <v-progress-circular
          :size="value * 0.6"
          width="1"
          indeterminate
          color="#DCDCDC"
          rotate="180"
        >
          <v-img
            class="pulseAnimation logoOpacity"
            src="@/assets/pandaMainLogo.svg"
            :max-width="value * 0.5"
          ></v-img>
        </v-progress-circular>
      </v-progress-circular>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'LoadingLogo',
  data: function () {
    return {}
  },
  props: {
    value: {
      type: Number,
      default: 100,
    },
  },
}
</script>

<style lang="scss" scoped>
.pulseAnimation {
  animation: pulse 2s linear infinite;
}

.logoOpacity {
  opacity: 0.85;
}

@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
